import { getPersistedLiveChatComponents } from 'actions/workflows-v2/workflowsV2';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import { selectLiveChatIntegration } from 'reducers/live-chat';
import { selectIsMobile } from 'reducers/main';
import { selectIsLiveChatMode } from 'reducers/workflows';

const integrationsWithPersistedLiveChatComponents = ['freshchat', 'intercom'];

export const useGetPersistedLiveChatComponents = () => {
  const dispatch = useAppDispatch();
  const isLiveChatMode: boolean = useAppSelector(selectIsLiveChatMode);
  const liveChatIntegration = useAppSelector(selectLiveChatIntegration);
  const isMobile = useAppSelector(selectIsMobile);

  const shouldGetPersistedLiveChatComponents =
    isLiveChatMode &&
    liveChatIntegration &&
    integrationsWithPersistedLiveChatComponents.includes(liveChatIntegration);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (
        isMobile &&
        document.visibilityState === 'visible' &&
        shouldGetPersistedLiveChatComponents
      ) {
        dispatch(getPersistedLiveChatComponents());
      }
    };

    if (shouldGetPersistedLiveChatComponents) {
      dispatch(getPersistedLiveChatComponents());
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [
    dispatch,
    isLiveChatMode,
    liveChatIntegration,
    shouldGetPersistedLiveChatComponents,
    isMobile,
  ]);
};
